import React from 'react'
import { useAtom } from 'jotai'
import Classnames from 'classnames'

// helper functions
import { returnValue } from '@/utils/op-types/helperFunctions'

import ReactPlayer from 'react-player'

// store
import {
  isBuilder,
  manifestStatic,
  pageContentStatic,
  manifestDesign,
  pageContentDesign,
  manifestBlocks,
  pageContentBlocks,
  collectionData,
} from '@/utils/op-types/store'

// icons
import { RiExternalLinkLine, RiArrowRightLine } from 'react-icons/ri'

// block renderer
import BlockRenderer from '@/components/optypes/frontend/BlockRenderer'

// block builder tools
import StaticContentWrapper from '@/components/optypes/frontend/StaticContentWrapper'
import AddBlockBuilder from '@/components/optypes/frontend/AddBlockBuilder'

// blocks
// import Block1 from '@/components/optypes/frontend/HubPage/blocks/Block1'

const Components = {
  // block_1: Block1,
}

const MainComponentRenderer = ({ children }) => {
  const [builder] = useAtom(isBuilder)
  // manifest settings
  const [opStatic] = useAtom(manifestStatic)
  const [opDesign] = useAtom(manifestDesign)
  const [opBlocks] = useAtom(manifestBlocks)
  // custom page settings
  const [pageStatic] = useAtom(pageContentStatic)
  const [pageDesign] = useAtom(pageContentDesign)
  const [pageBlocks] = useAtom(pageContentBlocks)
  // collection data
  const [getCollectionData] = useAtom(collectionData)

  return (
    <div
      className="min-h-screen"
      style={{
        backgroundColor: returnValue('bgcolor', opDesign, pageDesign),
        color: returnValue('textcolor', opDesign, pageDesign),
      }}
    >
      {/* background image */}
      {returnValue('bgimage', opDesign, pageDesign) && (
        <div
          className="fixed top-0 left-0 z-0 h-full w-full  bg-cover bg-no-repeat"
          style={{
            backgroundImage: `url(${returnValue(
              'bgimage',
              opDesign,
              pageDesign
            )})`,
            opacity: returnValue('bgimageopacity', opDesign, pageDesign),
          }}
        ></div>
      )}

      <div className="container max-w-7xl mx-auto relative z-10">
        {/* header collection */}
        <div className="flex items-center justify-between space-x-3 py-12">
          <div className="flex items-center space-x-3">
            {getCollectionData.logo && (
              <div className="">
                <img src={getCollectionData.logo} className="h-7 w-auto" />
              </div>
            )}

            {getCollectionData.brand && (
              <div className="font-bold">{getCollectionData.brand}</div>
            )}
          </div>

          <div className="flex items-center space-x-6">
            {returnValue('link1text', opStatic, pageStatic) && (
              <StaticContentWrapper contentKey="link1text">
                <div
                  onClick={() => {
                    if (!builder) {
                      if (returnValue('link1url', opStatic, pageStatic)) {
                        window
                          .open(
                            returnValue('link1url', opStatic, pageStatic),
                            '_blank'
                          )
                          .focus()
                      }
                    }
                  }}
                  className="font-medium flex items-center pb-1 border-b-2 border-black border-opacity-25 cursor-pointer hover:border-opacity-50"
                >
                  <div className="">
                    {returnValue('link1text', opStatic, pageStatic)}
                  </div>
                  <div className="ml-1.5 opacity-50">
                    <RiExternalLinkLine />
                  </div>
                </div>
              </StaticContentWrapper>
            )}

            {returnValue('link2text', opStatic, pageStatic) && (
              <StaticContentWrapper contentKey="link2text">
                <div
                  onClick={() => {
                    if (!builder) {
                      if (returnValue('link2url', opStatic, pageStatic)) {
                        window
                          .open(
                            returnValue('link2url', opStatic, pageStatic),
                            '_blank'
                          )
                          .focus()
                      }
                    }
                  }}
                  className="font-medium flex pb-1 items-center border-b-2 border-black border-opacity-25 cursor-pointer hover:border-opacity-50"
                >
                  <div className="">
                    {returnValue('link2text', opStatic, pageStatic)}
                  </div>
                  <div className="ml-1.5 opacity-50">
                    <RiExternalLinkLine />
                  </div>
                </div>
              </StaticContentWrapper>
            )}
          </div>
        </div>

        {/* big header */}
        <div className="flex items-center">
          {/* headline */}
          <div className="w-1/2 mr-20">
            <div className="font-bold text-6xl appTitleItem">
              <StaticContentWrapper contentKey="headline">
                {pageStatic['headline']
                  ? pageStatic['headline']
                  : getCollectionData.title}
              </StaticContentWrapper>
            </div>
            <div className="mt-6 text-lg">
              {/* show in builder */}
              {builder && (
                <StaticContentWrapper contentKey="subheadline">
                  {returnValue('subheadline', opStatic, pageStatic)}
                </StaticContentWrapper>
              )}
              {/* conditional show in view */}
              {!builder &&
                returnValue('subheadline', opStatic, pageStatic) !==
                  'Optional Sub Headline...' && (
                  <StaticContentWrapper contentKey="subheadline">
                    {returnValue('subheadline', opStatic, pageStatic)}
                  </StaticContentWrapper>
                )}
            </div>

            <div className="mt-6">
              {/* show in builder */}
              {builder && (
                <StaticContentWrapper contentKey="ctabuttontext">
                  <div
                    onClick={() => {
                      if (!builder) {
                        if (returnValue('ctabuttonurl', opStatic, pageStatic)) {
                          window
                            .open(
                              returnValue('ctabuttonurl', opStatic, pageStatic),
                              '_blank'
                            )
                            .focus()
                        }
                      }
                    }}
                    className="inline-flex items-center  font-bold text-lg cursor-pointer transition transform shadow hover:shadow-lg hover:scale-105 rounded py-4 px-6"
                    style={{
                      backgroundColor: returnValue(
                        'ctabuttoncolor',
                        opStatic,
                        pageStatic
                      ),
                      color: returnValue(
                        'ctabuttontextcolor',
                        opStatic,
                        pageStatic
                      ),
                    }}
                  >
                    <div className="mr-3">
                      {returnValue('ctabuttontext', opStatic, pageStatic)}
                    </div>

                    <div className="">
                      <RiExternalLinkLine />
                    </div>
                  </div>
                </StaticContentWrapper>
              )}

              {!builder &&
                returnValue('ctabuttontext', opStatic, pageStatic) !==
                  'Edit Button' && (
                  <StaticContentWrapper contentKey="ctabuttontext">
                    <div
                      onClick={() => {
                        if (!builder) {
                          if (
                            returnValue('ctabuttonurl', opStatic, pageStatic)
                          ) {
                            window
                              .open(
                                returnValue(
                                  'ctabuttonurl',
                                  opStatic,
                                  pageStatic
                                ),
                                '_blank'
                              )
                              .focus()
                          }
                        }
                      }}
                      className="inline-flex items-center  font-bold text-lg cursor-pointer transition transform shadow hover:shadow-lg hover:scale-105 rounded py-4 px-6"
                      style={{
                        backgroundColor: returnValue(
                          'ctabuttoncolor',
                          opStatic,
                          pageStatic
                        ),
                        color: returnValue(
                          'ctabuttontextcolor',
                          opStatic,
                          pageStatic
                        ),
                      }}
                    >
                      <div className="mr-3">
                        {returnValue('ctabuttontext', opStatic, pageStatic)}
                      </div>

                      <div className="">
                        <RiExternalLinkLine />
                      </div>
                    </div>
                  </StaticContentWrapper>
                )}
            </div>
          </div>

          {/* video / image */}
          <div className="w-1/2">
            {/* video */}
            {returnValue('videourl', opStatic, pageStatic) && (
              <div className="player-wrapper rounded shadow-lg overflow-hidden mb-8">
                <ReactPlayer
                  controls={false}
                  playing={false}
                  width="100%"
                  height="100%"
                  className="react-player"
                  url={returnValue('videourl', opStatic, pageStatic)}
                />
              </div>
            )}

            {/* img */}
            {returnValue('imgurl', opStatic, pageStatic) && (
              <img
                src={returnValue('imgurl', opStatic, pageStatic)}
                alt=""
                className="rounded shadow-lg mb-8"
              />
            )}
          </div>
        </div>

        {!builder && <div className="">{children}</div>}

        {builder && (
          <div className="py-20 text-lg italic font-medium text-center">
            Onepagers & Users Saved Onepagers Will Display Here...
          </div>
        )}
      </div>
    </div>
  )
}

export default MainComponentRenderer
